module.exports = __webpack_public_path__ + "img/4.7b57af7d.gif";